module.exports = __webpack_public_path__ + "img/44.135aca56.png";